export const getLastVisitProcessStatement = state => state.processStatement.lastActiveProcessStatement;
